import request from '@/utils/service'

export function userStatistics(data) {
  return request({
    url: '/statistics/userStatistics',
    method: 'get',
    params: data
  })
}

export function chargeOrderStatistics(data) {
  return request({
    url: '/statistics/chargeOrderStatistics',
    method: 'get',
    params: data
  })
}

export function rechargeOrderStatistics(data) {
  return request({
    url: '/statistics/rechargeOrderStatistics',
    method: 'get',
    params: data
  })
}

export function monthCardOrderStatistics(data) {
  return request({
    url: '/statistics/monthCardOrderStatistics',
    method: 'get',
    params: data
  })
}

export function storeStatistics(data) {
  return request({
    url: '/statistics/storeStatistics',
    method: 'get',
    params: data
  })
}
export function storeOrderStatistics(data) {
  return request({
    url: '/statistics/storeOrderStatistics',
    method: 'get',
    params: data
  })
}

export function queryHomeDashboard(data) {
  return request({
    url: '/statistics/queryHomeDashboard',
    method: 'get',
    params: data
  })
}

export function dashboardLog(data) {
  return request({
    url: '/dashboardLog/list',
    method: 'get',
    params: data
  })
}

export function read(data) {
  return request({
    url: '/dashboardLog/read',
    method: 'post',
    data
  })
}
